import React from 'react'
import "./Model_Internship.scss"
import Internship from '../components/Home/Internship/Internship'
import Domain from '../components/Home/Internship/Domain/Domain'
import { Helmet } from 'react-helmet'

const Model_Internship = () => {
  return (
    <>

  <Helmet>
  <title>IT Internship in Vadodara | V-Ex Tech Solution – Learn from Industry Experts</title>
  <meta
    name="title"
    content="IT Internship in Vadodara | V-Ex Tech Solution"
  />
  <meta
    name="description"
    content="Join V-Ex Tech Solution’s IT Internship in Vadodara and gain real-world experience in Python, MERN Stack, Data Analysis, Web Development, and more. 100% practical learning with guidance from industry professionals."
  />
  <meta
    name="keywords"
    content="IT internship in Vadodara, software internship Vadodara, Python internship Vadodara, web development internship, MERN stack internship, data analysis internship, V-Ex Tech Solution"
  />
  <meta name="author" content="V-Ex Tech Solution" />
</Helmet>



    <Internship />
    <Domain/>
    </>
  )
}

export default Model_Internship
